module.exports = __webpack_public_path__ + "video-360-icon.svg?1b9ce69309fede5101f445c7f46692f1";